<template>
	<div  :aria-busy="loading ? 'true' : 'false'">
		<section v-if="!loading">
			<div v-if="notification">
				<div v-if="(notification && notification.length > 0)">
					<table class="table--fixed reset-truncate">
						<thead>
							<tr>
								<th class="attachment-cell">{{ 'attachment' | translate | titleCase }}</th>
								<th class="message-cell">{{ 'message' | translate | titleCase }}</th>
								<th class="date-cell">{{ 'date' | translate | titleCase }}</th>
								<th class="supporters-cell">{{ 'supporters' | translate | titleCase }}</th>
								<th class="message-status-cell">{{ 'status' | translate | titleCase }}</th>
							</tr>
						</thead>
						<tfoot v-if="notification > 10">
							<tr>
								<th class="attachment-cell">Anexo</th>
								<th class="message-cell">{{ 'message' | translate | titleCase }}</th>
								<th class="date-cell">{{ 'date' | translate | titleCase }}</th>
								<th class="supporters-cell">{{ 'supportes' | translate | titleCase }}</th>
								<th class="message-status-cell">{{ 'status' | translate | titleCase }}</th>
							</tr>
						</tfoot>
						<tbody >
							<tr class="line" v-for="(notification) in notification" :key="notification.campaign_id">
								<td :aria-label="'midia' | translate" class="attachment-cell"><i v-if="notification.saved_attachment_id" class="fas fa-paperclip"></i></td>
								<td :title="notification.content" :aria-label="'message' | translate" class="message-cell">{{notification.content}}</td>
								<td :tile="notification.created_at | date" :aria-label="'date' | translate" class="date-cell">{{notification.created_at | date }}</td>
								<td :title="notification.count" :aria-label="'supporters' | translate" class="supporters-cell"><span class="supporters-cell__content">{{ notification.count }}</span></td>
								<td :title="'sent' | translate | titleCase" :aria-label="'status' | translate"><span v-if="notification.status === 'sent'" class="status__icon">{{ 'sent' | translate | titleCase }}</span><span v-else class="status-cell__content">{{ 'processing' | translate | titleCase }}</span></td>
							</tr>
						</tbody>
					</table>

					<pagination
					:classNames="'pagination-arrows pull-right'"
					dispatchToCall="getCampaigns"
					:itemsPerPageProp="session.results"
					:totalItensPagesProps="totalPages"
					:totalItens="totalItems"
					:totalPagesProp="totalPages"
					></pagination>
				</div>
				<div v-else>
					no results
				</div>
			</div>
			<div v-else>
				<p class="empty-state">
					{{ 'no-campaigns' | translate | capitalize }}
				</p>
			</div>
		</section>
	</div>
</template>
<script>
import pagination from '../../components/pagination/pagination.vue';


export default {
	name: 'campaigns',
	data() {
		return {
			loading: false,
			session: {
				page: 1,
				results: 20,
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
			},
			notifications: {},
		};
	},
	components: {
		pagination,
	},
	computed: {
		user() {
			return this.$store.state.user;
		},
		success() {
			return this.$store.state.status;
		},
		notification() {
			return (this.$store.state.campaign.campaigns || '').direct_messages || '';
		},
		totalItems() {
			return (this.$store.state.campaign.campaigns || 0).itens_count || 0;
		},
		pendingMessageStatus: {
			get() {
				return (this.notification || []).filter(g => g.status === 'processing').length;
			},
			set(value) {
				this.pendingMessageStatus = value;
			},
		},
		totalPages: {
			get() {
				return this.totalItems / this.session.results || 0;
			},
			set() {
			},
		},
	},
	methods: {
		campaignsDetails(id) {
			this.$router.push({ path: '/campanha', query: { id } });
		},
		toggleLoading() {
			this.loading = !this.loading;
		},
		verifyStatus() {
			const timer = setInterval(() => {
				if (this.pendingMessageStatus) {
					this.$store.dispatch('getCampaigns', this.session);
				} else {
					clearInterval(timer);
				}
			}, 2000);
		},
	},
	mounted() {
		this.toggleLoading();
		this.$store.dispatch('getCampaigns', this.session)
			.then(() => {
				this.toggleLoading();
			})
			.catch(() => {
				this.toggleLoading();
			});
		this.verifyStatus();
	},
};
</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/campaign/campaigns.vue